export const T = {
  en_GB: {
    noProductsYet:
      "No products added yet. Use the Custom Portfolio Builder to add products to this portfolio.",
    completeRiskAssessment:
      "Please complete the risk assessment to see your recommended portfolio.",
    enterInvestmentAmount: "Please enter an investment amount to see your portfolio allocation.",
    noPortfolioForScore: (score: string) =>
      `No portfolio available for risk score ${score}. Please contact your advisor to see your portfolio allocation.`,
    errorLoadingRiskAssessment: "Error loading risk assessment data. Please refresh the page.",
    errorLoadingPortfolio: "Error loading portfolio data. Please refresh the page.",
    portfolioNoAmounts:
      "Portfolio products have no amounts set. Please add amounts in the Custom Portfolio Builder.",
    snapshotMissingMessage:
      "Portfolio information needs to be regenerated. Use the Regenerate button above.",
  },
  nb_NO: {
    noProductsYet:
      "Ingen produkter lagt til ennå. Bruk Egendefinert porteføljebygger for å legge til produkter i denne porteføljen.",
    completeRiskAssessment: "Fullfør risikovurderingen for å se din anbefalte portefølje.",
    enterInvestmentAmount: "Angi et investeringsbeløp for å se din porteføljeallokering.",
    noPortfolioForScore: (score: string) =>
      `Ingen portefølje tilgjengelig for risikoskår ${score}. Kontakt din rådgiver for å se din porteføljeallokering.`,
    errorLoadingRiskAssessment: "Feil ved lasting av risikovurdering. Oppdater siden.",
    errorLoadingPortfolio: "Feil ved lasting av porteføljedata. Oppdater siden.",
    portfolioNoAmounts:
      "Porteføljeprodukter har ingen beløp satt. Legg til beløp i Egendefinert porteføljebygger.",
    snapshotMissingMessage: "Porteføljeinformasjon må regenereres. Bruk Regenerer-knappen over.",
  },
} as const;
